/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.875.9278a2.75 2.75 0 0 0-2.75 0L2.0317 5.0231a2.75 2.75 0 0 0-1.375 2.3816v8.1906c0 .9825.5242 1.8903 1.375 2.3816l6.5933 3.8066c1.1667.6736 2.625-.1684 2.625-1.5156v-9.292l7.5933-3.5733V11.5a.75.75 0 0 0 1.5 0V7.4047a2.7501 2.7501 0 0 0-1.375-2.3816L11.875.9278Zm6.073 5.2383L10.5 9.6711 3.052 6.166 9.875 2.227a1.25 1.25 0 0 1 1.25 0l6.823 3.9392Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.5303 14.4697a.75.75 0 0 0-1.0606 0 .75.75 0 0 0 0 1.0606l2.7196 2.7197H14a.75.75 0 0 0 0 1.5h7.1893l-2.7196 2.7197a.75.75 0 0 0 0 1.0606.75.75 0 0 0 1.0606 0L24.0607 19l-4.5304-4.5303Z"
    />
  </React.Fragment>,
  'MenuDeliveryInsightsFilled'
);
